import authenticate from "./authenticate.js";
export default authenticate;
